import React from "react";
import { styled, View } from "tamagui";

// Minimal, intentional port of web-hub's SkeletonBox
// (packages/web-hub/src/components/common/SkeletonBox.tsx) — same props,
// same static-opacity approach, zero animation. Kept as a byte-for-byte-close
// twin (not a cross-package import; the two packages don't share a UI
// component layer beyond tamagui-config tokens) so a later design-system
// migration can dedupe the two without a behaviour change.
const SkeletonContainer = styled(View, {
  backgroundColor: "$transparentBorder",
  borderRadius: "$3",
  opacity: 0.6,
});

export interface SkeletonBoxProps {
  width?: number | string;
  height?: number | string;
  borderRadius?: string;
}

export const SkeletonBox: React.FC<SkeletonBoxProps> = ({
  width = "100%",
  height = 20,
  borderRadius = "$3",
}) => (
  <SkeletonContainer width={width} height={height} borderRadius={borderRadius} />
);
